import { useEffect, useState } from "react";
import { useDropdownApi } from "../Services/api/dropdownApi";
import { AdvancedFilters } from "../types/filters";
import { DropdownOptions } from "../types/dropdown";
import React from "react";
import { useLoader } from "../components/common/LoaderContext";
// import { convertKeysToString } from "../pages/Comments";
import { useBalanceSheetApi } from "../Services/api";
import { useQueryParams } from "./useQueryParams";

export interface LandscapeInfoItem {
  LandscapeId: number;
}
export interface UserData {
  UserID: string | number;
  LandscapeInfo: LandscapeInfoItem[];
}

export function useDropdowns(
  userData: UserData,
  handleFilterChangeWithWarning: (
    key: keyof AdvancedFilters,
    value: string | string[],
  ) => boolean,
  setCurrency: (currency: string) => void,
) {
  const { getQueryParams } = useQueryParams();
  const queryParams = getQueryParams();
  const { getThresholdValues } = useBalanceSheetApi();
  const [thresholdValues, setThresholdValues] = React.useState<any>({});
  const {
    getMarketDropdownValues,
    getMcoDropdownValues,
    getCountryDropdownValues,
    getCompanyCodes,
    getReviewScenarioValues,
    getAllPeriodDetails,
  } = useDropdownApi();

  const { setLoading } = useLoader();
  const { countryBasedMarketValues } = useDropdownApi();
  const [queryParamsUsed, setQueryParamsUsed] = React.useState(false);
  const [filters, setFilters] = React.useState<AdvancedFilters>({
    marketvalue: queryParams.MarketValue || "",
    mco: queryParams.MCO,
    country: queryParams.Country,
    companycodes: queryParams.CompanyCodes
      ? queryParams.CompanyCodes.split(",").map((c) => c.trim())
      : [],
    reportingyear: Number(queryParams.RptYear) || "",
    reportingmonth: Number(queryParams.RptMonthNo) || 0,
    comparisonyear: Number(queryParams.CompYear) || "",
    comparisonmonth: Number(queryParams.CompMonthNo) || 0,
    plreportingyear: Number(queryParams.RptYear) || "",
    plreportingmonth: Number(queryParams.RptMonthNo) || 0,
    plcomparisonyear: Number(queryParams.CompYear) || "",
    plcomparisonmonth: Number(queryParams.CompMonthNo) || 0,
    reviewscenario: queryParams.ReviewScenario || "",
  });
  console.log(filters.reportingyear, "filters.reportingyear");
  const landscapeId =
    queryParams.LandscapeID === ""
      ? userData?.LandscapeInfo && userData.LandscapeInfo.length > 0
        ? userData.LandscapeInfo[0]?.LandscapeId
        : undefined
      : queryParams.LandscapeID;
  const [dropdownOptions, setDropdownOptions] = React.useState<DropdownOptions>(
    {
      marketvalue: [],
      mco: [],
      country: [],
      companycodes: [],
      thresholdvalues: [],
      reportingyear: [],
      reportingmonth: [],
      comparisonyear: [],
      comparisonmonth: [],
      plreportingyear: [],
      plreportingmonth: [],
      plcomparisonyear: [],
      plcomparisonmonth: [],
      reviewscenario: [],
      currency: [],
      currencycode: [],
    },
  );
  const [reportingAndComparison, setReportingAndComparison] = useState([]);
  const companyCodesString = Array.isArray(filters.companycodes)
    ? filters.companycodes.join(",")
    : filters.companycodes;

  function deduplicateByKey<T extends { key: any }>(arr: T[]): T[] {
    const sorted = [...arr].sort((a, b) => {
      // If keys are numbers, sort numerically; otherwise, sort as strings
      const aKey = isNaN(Number(a.key)) ? String(a.key) : Number(a.key);
      const bKey = isNaN(Number(b.key)) ? String(b.key) : Number(b.key);
      if (aKey < bKey) return 1;
      if (aKey > bKey) return -1;
      return 0;
    });
    const seen = new Set();
    return sorted.filter((item) => {
      const k = String(item.key);
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }
  //  Handle dropdown value changes
  const handleFilterChange = (
    key: keyof AdvancedFilters,
    value: string | string[],
  ) => {
    // uncomment this when commenting below
    // const updatedFilters = { ...filters, [key]: value };
    // setFilters(updatedFilters);
    //working for show modal on comments change
    const params = new URLSearchParams(window.location.search);
    const keepKeys = ["LandscapeID", "CBTType"];
    const newParams = new URLSearchParams();
    keepKeys.forEach((k) => {
      const v = params.get(k);
      if (v !== null) newParams.set(k, v);
    });
    const cleanUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      (newParams.toString() ? "?" + newParams.toString() : "");
    window.history.replaceState({}, document.title, cleanUrl);

    let proceed = false;

    if (handleFilterChangeWithWarning) {
      proceed = handleFilterChangeWithWarning(key, value);
    }

    if (proceed) {
      if (key === "companycodes") {
        // If value is empty string or empty array, don't update filters
        // if (!value || (typeof value === 'string' && value.trim() === '') ||
        //   (Array.isArray(value) && value.length === 0)) {
        //   return;
        // }
        let newValue: string[] = [];
        if (typeof value === "string") {
          newValue = value.split(",").filter((v) => v.trim() !== "");
        } else if (Array.isArray(value)) {
          newValue = value.filter((v) => v.trim() !== "");
        }

        setFilters({
          ...filters,
          companycodes: newValue,
        });
      } else {
        setQueryParamsUsed(true);
        const updatedFilters = { ...filters, [key]: value };
        setFilters(updatedFilters);
      }
      // const updatedFilters = { ...filters, [key]: value };
      // setFilters(updatedFilters);
    }
  };

  useEffect(() => {
    const fetchMarketDropdownOptions = async () => {
      // Always get all market options
      let res = await getMarketDropdownValues({
        userId: userData?.UserID,
        landScapeId: landscapeId,
      });
      let marketOptions: { key: string; value: string }[] = [];
      if (res) {
        marketOptions = res.map((item: any) => ({
          key: item.keyz,
          value: item.valuez,
          // tooltip: item.valuez,
        }));
        setDropdownOptions((prev: any) => ({
          ...prev,
          marketvalue: marketOptions,
        }));
      }

      // If Country is present in query params, set selected market value from countryBasedMarketValues
      if (queryParams.Country) {
        let countryMarketResponse = await countryBasedMarketValues({
          countryCode: queryParams.Country,
        });
        if (countryMarketResponse && countryMarketResponse.length > 0) {
          // Assume you want to select the first value from the country-based response
          const selectedMarketKey = String(countryMarketResponse[0].keyz);
          setFilters((prev) => ({
            ...prev,
            marketvalue: selectedMarketKey,
          }));
        }
      } else if (!queryParams.MarketValue) {
        // If no query param for MarketValue, select the first from all options
        setFilters((prev) => ({
          ...prev,
          marketvalue:
            !prev.marketvalue ||
            !marketOptions.some(
              (opt: { key: string }) => opt.key === prev.marketvalue,
            )
              ? marketOptions.length > 0
                ? String(marketOptions[0].key)
                : ""
              : prev.marketvalue,
        }));
      }
    };

    const fetchReviewScenarioDropdownOptions = async () => {
      let response = await getReviewScenarioValues();
      if (response) {
        const RSOptions = response.map((item: any) => ({
          key: item.ReviewScenarioID,
          value: item.ReviewScenario,
          tooltip: item.ReviewScenario,
        }));
        setDropdownOptions((prev) => ({
          ...prev,
          reviewscenario: RSOptions,
        }));
        setFilters((prev) => {
          const latestReviewScenario =
            !prev.reviewscenario ||
            !RSOptions.some(
              (opt: { key: number }) => String(opt.key) === prev.reviewscenario,
            )
              ? // Find the key for "Review Required"
                (RSOptions.find(
                  (opt: { value: string }) => opt.value === "Review Required",
                )?.key ??
                (RSOptions.length > 0 ? String(RSOptions[0].key) : ""))
              : prev.reviewscenario;
          return {
            ...prev,
            reviewscenario: latestReviewScenario,
          };
        });
      }
    };
    fetchMarketDropdownOptions();
    fetchReviewScenarioDropdownOptions();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchMcoDropdownOptions = async () => {
      let response = await getMcoDropdownValues({
        userId: userData?.UserID,
        landscapeId: landscapeId,
        marketValue: filters.marketvalue,
      });
      if (response) {
        const mcoOptions = response.map((item: any) => ({
          key: item.keyz,
          value: item.valuez,
          tooltip: item.valuez,
        }));
        setDropdownOptions((prev) => ({
          ...prev,
          mco: mcoOptions,
        }));
        if (!queryParamsUsed && !queryParams.MCO) {
          setFilters((prev) => ({
            ...prev,
            mco:
              !prev.mco ||
              !mcoOptions.some((opt: { key: string }) => opt.key === prev.mco)
                ? mcoOptions.length > 0
                  ? String(mcoOptions[0].key)
                  : ""
                : prev.mco,
          }));
        } else if (!queryParamsUsed && queryParams.MCO) {
          const matchedmco = mcoOptions.find(
            (opt: { key: string }) =>
              String(opt.key) === String(queryParams.MCO),
          );
          setFilters((prev) => ({
            ...prev,
            mco: matchedmco
              ? String(matchedmco.key)
              : mcoOptions.length > 0
                ? String(mcoOptions[0].key)
                : "",
          }));
        } else {
          setFilters((prev) => ({
            ...prev,
            mco: mcoOptions.length > 0 ? String(mcoOptions[0].key) : "",
          }));
        }
      }
    };
    fetchMcoDropdownOptions();
    // eslint-disable-next-line
  }, [filters.marketvalue, landscapeId, userData?.UserID, queryParams.MCO]);

  // useeffect to fetch dropdown options based on mco which is available inside the filters
  useEffect(() => {
    const fetchDropdownOptions = async () => {
      setLoading(true);
      console.log(filters.mco, "mco");
      let response = await getCountryDropdownValues({
        userId: userData?.UserID,
        landscapeId: landscapeId,
        mco: filters.mco,
        marketValue: filters.marketvalue,
      });
      if (response) {
        const countryOptions = response.map((item: any) => ({
          key: item.keyz,
          value: item.valuez,
          CurrencyCode: item.CurrencyCode,
          countryName: item.CountryName,
          tooltip: item.CountryName,
        }));
        if (countryOptions.length > 0) {
          setFilters((prev) => {
            // If no country or invalid country, set to first option
            if (
              !prev.country ||
              !countryOptions.some(
                (opt: any) => String(opt.key) === String(prev.country),
              )
            ) {
              return {
                ...prev,
                country:
                  countryOptions && countryOptions.length > 0
                    ? String(countryOptions[0].key)
                    : "",
              };
            }
            return prev;
          });
        }
        setDropdownOptions((prev) => ({
          ...prev,
          country: countryOptions,
        }));
        if (!queryParamsUsed && !queryParams.Country) {
          setFilters((prev) => ({
            ...prev,
            country:
              !prev.country ||
              !countryOptions.some(
                (opt: { key: string }) =>
                  String(opt.key) === String(prev.country),
              )
                ? countryOptions.length > 0
                  ? countryOptions[0].key
                  : ""
                : prev.country,
          }));
        } else if (!queryParamsUsed && queryParams.Country) {
          const matchedCountry = countryOptions.find(
            (opt: { key: string }) =>
              String(opt.key) === String(queryParams.Country),
          );
          setFilters((prev) => ({
            ...prev,
            country: matchedCountry
              ? String(matchedCountry.key)
              : countryOptions.length > 0
                ? String(countryOptions[0].key)
                : "",
          }));
        } else {
          setFilters((prev) => {
            // If no country or invalid country, set to first option
            if (
              !prev.country ||
              !countryOptions.some(
                (opt: any) => String(opt.key) === String(prev.country),
              )
            ) {
              return {
                ...prev,
                country:
                  countryOptions && countryOptions.length > 0
                    ? String(countryOptions[0].key)
                    : "",
              };
            }
            return prev;
          });
        }
        const selectedCountry = countryOptions.find(
          (opt: any) => String(opt.key) === String(filters.country),
        );
        if (selectedCountry && selectedCountry.CurrencyCode) {
          setCurrency(selectedCountry.CurrencyCode);
        }
      }
      setLoading(false);
    };
    if (filters.mco && filters.marketvalue) {
      fetchDropdownOptions();
    }
  }, [filters.marketvalue, filters.mco, filters.country, queryParams.Country]);

  //use effect when country changes, marketvalue changes and query params are not used
  useEffect(() => {
    const fetchCompanyCodeDropdownOptions = async () => {
      if (filters.country) {
        setLoading(true);
        let response = await getCompanyCodes({
          userId: userData?.UserID,
          landscapeId: landscapeId,
          countryCode: filters.country,
          mco: filters.mco,
        });
        if (response) {
          const companyCodeOptions = response.map((item: any) => ({
            key: item.keyz,
            value: `${item.valuez} - ${item.CompanyName} `,
          }));
          setDropdownOptions((prev) => ({
            ...prev,
            companycodes: companyCodeOptions,
          }));
          const allCompanyCodes = companyCodeOptions.map((opt: any) =>
            String(opt.key),
          );
          // Select all company codes by default
          if (!queryParamsUsed && queryParams.CompanyCodes) {
            setFilters((prev) => ({
              ...prev,
              companycodes: queryParams.CompanyCodes.split(",").map((c) =>
                c.trim(),
              ),
            }));
          } else if (queryParams.CompanyCodes) {
            setFilters((prev) => ({
              ...prev,
              companycodes: queryParams.CompanyCodes.split(",").map((c) =>
                c.trim(),
              ),
            }));
          } else {
            setFilters((prev) => ({
              ...prev,
              companycodes: allCompanyCodes,
            }));
          }
        }
        setLoading(false);
      }
    };

    fetchCompanyCodeDropdownOptions();
  }, [filters.mco, filters.country, queryParamsUsed]);

  //use effect when mco and country changes calling all perido
  useEffect(() => {
    const fetchAllReportingAndComparisonDetails = async () => {
      setLoading(true);
      if (filters.marketvalue && filters.country) {
        let response = await getAllPeriodDetails({
          market: filters.marketvalue,
          countryCode: filters.country,
        });
        if (response) {
          setReportingAndComparison(response);
          const RPOptions = response
            .filter((item: any) => item.PeriodType === "RP")
            .map((item: any) => ({
              key: item.ReportingYear,
              value: item.ReportingYear,
            }));
          const RPMonths = response
            .filter(
              (item: any) =>
                item.PeriodType === "RP" &&
                String(item.ReportingYear) === String(filters.reportingyear),
            )
            .map((item: any) => ({
              key: item.ReportingMonth,
              value: item.ReportingMonth,
            }));
          const CPOptions = response
            .filter((item: any) => item.PeriodType === "CP")
            .map((item: any) => ({
              key: item.ReportingYear,
              value: item.ReportingYear,
            }));
          const CPMonths = response
            .filter(
              (item: any) =>
                item.PeriodType === "CP" &&
                String(item.ReportingYear) === String(filters.comparisonyear),
            )
            .map((item: any) => ({
              key: item.ReportingMonth,
              value: item.ReportingMonth,
            }));
          const reportingMonthNum = Number(filters.reportingmonth);
          const currentIndex = CPMonths.findIndex(
            (m: any) => Number(m.key) === reportingMonthNum,
          );
          const nextMonth =
            currentIndex !== -1 && CPMonths[currentIndex + 1]
              ? CPMonths[currentIndex + 1].value
              : CPMonths[0]?.value;
          const PlCPMonths = response
            .filter(
              (item: any) =>
                item.PeriodType === "CP" &&
                item.ReportingYear ===
                  (Number(filters.reportingyear) - 1).toString(),
            )
            .map((item: any) => ({
              key: item.ReportingMonth,
              value: item.ReportingMonth,
            }));
          setDropdownOptions((prev) => ({
            ...prev,
            reportingyear: deduplicateByKey(RPOptions),
            reportingmonth: deduplicateByKey(RPMonths),
            comparisonyear: deduplicateByKey(CPOptions),
            comparisonmonth: deduplicateByKey(CPMonths),
            plreportingyear: deduplicateByKey(RPOptions),
            plreportingmonth: deduplicateByKey(RPMonths),
            plcomparisonyear: deduplicateByKey(CPOptions),
            plcomparisonmonth: deduplicateByKey(PlCPMonths),
          }));
          // when query params are not used and rptyear is not in query params
          if (!queryParamsUsed && !queryParams.RptYear) {
            setFilters((prev) => ({
              ...prev,
              reportingyear: RPOptions[0]?.value,
              reportingmonth: RPMonths[0]?.value,
              comparisonyear: CPOptions[0]?.value,
              comparisonmonth: nextMonth,
              plreportingyear: RPOptions[0]?.value,
              plreportingmonth: RPMonths[0]?.value,
              plcomparisonyear: String(RPOptions[RPOptions.length - 1].value),
              plcomparisonmonth: CPMonths[0]?.value,
            }));
          } else if (!queryParamsUsed && queryParams.RptYear) {
            const matchedYear = RPOptions.find(
              (opt: { value: number }) =>
                String(opt.value) === String(queryParams.RptYear),
            );
            setFilters((prev) => ({
              ...prev,
              reportingyear: matchedYear
                ? String(matchedYear.value)
                : RPOptions.length > 0
                  ? String(RPOptions[RPOptions.length - 1].value)
                  : prev.reportingyear,
              plcomparisonyear: matchedYear
                ? String(Number(matchedYear.value) - 1)
                : RPOptions.length > 0
                  ? String(Number(RPOptions[RPOptions.length - 1].value) - 1)
                  : "",
            }));
          } else {
            setFilters((prev) => {
              return {
                ...prev,
                reportingyear: RPOptions[0]?.value,
                reportingmonth: RPMonths[0]?.value,
                comparisonyear: CPOptions[0]?.value,
                comparisonmonth: nextMonth,
                plreportingyear: RPOptions[0]?.value,
                plreportingmonth: RPMonths[0]?.value,
                plcomparisonyear: RPOptions[0]?.value
                  ? String(Number(RPOptions[0]?.value) - 1)
                  : "",
                plcomparisonmonth: RPMonths[0]?.value,
              };
            });
          }
        }
      }
      setLoading(false);
    };
    fetchAllReportingAndComparisonDetails();
  }, [filters.mco, filters.country]);

  //use effect when reporting year changes and reportingmonth changes
  useEffect(() => {
    const isReportingYear = (item: any, filters: any) => {
      return (
        item.PeriodType === "RP" &&
        String(item.ReportingYear) === String(filters.reportingyear)
      );
    };
    const RPYears = reportingAndComparison
      .filter((item: any) => item.PeriodType === "RP")
      .map((item: any) => ({
        key: item.ReportingYear,
        value: item.ReportingYear,
      }));
    const RPMonths = reportingAndComparison
      .filter((item: any) => isReportingYear(item, filters))
      .map((item: any) => ({
        key: item.ReportingMonth,
        value: item.ReportingMonth,
      }));

    const CPYears = reportingAndComparison
      .filter((item: any) => item.PeriodType === "CP")
      .map((item: any) => ({
        key: item.ReportingYear,
        value: item.ReportingYear,
      }));
    // Check if the currently selected reporting month is the last option
    const sortedMonths = [...RPMonths].sort(
      (a: any, b: any) => Number(b.key) - Number(a.key),
    );
    const isLastReportingMonth =
      sortedMonths.length > 0 &&
      String(filters.reportingmonth) ===
        String(sortedMonths[sortedMonths.length - 1].key);

    // Determine comparison year based on whether it's the last month
    let comparisonYearToUse: string;
    if (isLastReportingMonth) {
      // If last month, use reporting year - 1
      comparisonYearToUse = (Number(filters.reportingyear) - 1).toString();
    } else {
      // Otherwise, use same as reporting year
      comparisonYearToUse = filters.reportingyear.toString();
    }
    const CPMonths = reportingAndComparison
      .filter(
        (item: any) =>
          item.PeriodType === "CP" &&
          item.ReportingYear === comparisonYearToUse,
      )
      .map((item: any) => ({
        key: item.ReportingMonth,
        value: item.ReportingMonth,
      }));
    const reportingMonthNum = Number(filters.reportingmonth);
    const currentIndex = CPMonths.findIndex(
      (m) => Number(m.key) === reportingMonthNum,
    );
    const nextMonth =
      currentIndex !== -1 && CPMonths[currentIndex + 1]
        ? CPMonths[currentIndex + 1].value
        : CPMonths[0]?.value;
    const PLCPMonths = reportingAndComparison
      .filter(
        (item: any) =>
          item.PeriodType === "CP" &&
          item.ReportingYear === (Number(filters.reportingyear) - 1).toString(),
      )
      .map((item: any) => ({
        key: item.ReportingMonth,
        value: item.ReportingMonth,
      }));
    setDropdownOptions((prev: any) => ({
      ...prev,
      reportingmonth: deduplicateByKey(RPMonths),
      comparisonyear: deduplicateByKey(CPYears),
      // comparisonmonth: deduplicateByKey(CPMonths),
      plreportingyear: deduplicateByKey(RPYears),
      plreportingmonth: deduplicateByKey(RPMonths),
      plcomparisonyear: deduplicateByKey(CPYears),
      plcomparisonmonth: deduplicateByKey(PLCPMonths),
    }));
    if (!queryParamsUsed && !queryParams.RptYear) {
      setFilters((prev: any) => ({
        ...prev,
        reportingmonth:
          prev.reportingmonth &&
          RPMonths.some(
            (m: any) => String(m.value) === String(prev.reportingmonth),
          )
            ? prev.reportingmonth
            : RPMonths[0]?.value,
        comparisonyear: comparisonYearToUse,
        comparisonmonth: nextMonth,
        plreportingyear: filters.reportingyear,
        plreportingmonth: filters.reportingmonth,
        plcomparisonyear: (Number(filters.reportingyear) - 1).toString(),
        plcomparisonmonth: filters.reportingmonth,
      }));
    } else if (!queryParamsUsed && queryParams.RptYear) {
      const matchedMonth = RPMonths.find(
        (opt: { value: number }) =>
          String(opt.value) === String(queryParams.RptMonthNo),
      );
      setFilters((prev: any) => ({
        ...prev,
        reportingmonth: matchedMonth
          ? String(matchedMonth.value)
          : prev.reportingmonth,
        comparisonyear: comparisonYearToUse,
        plreportingmonth: matchedMonth
          ? String(matchedMonth.value)
          : prev.reportingmonth,
        plcomparisonmonth: matchedMonth
          ? String(matchedMonth.value)
          : prev.reportingmonth,
        plcomparisonyear: (Number(queryParams.RptYear) - 1).toString(),
      }));
    } else {
      setFilters((prev: any) => {
        return {
          ...prev,
          reportingmonth:
            prev.reportingmonth &&
            RPMonths.some(
              (m: any) => String(m.value) === String(prev.reportingmonth),
            )
              ? prev.reportingmonth
              : RPMonths[0]?.value,
          comparisonmonth: nextMonth,
          comparisonyear: comparisonYearToUse,
          plreportingyear: filters.reportingyear,
          plreportingmonth: filters.reportingmonth,
          plcomparisonyear: (Number(filters.reportingyear) - 1).toString(),
          plcomparisonmonth: filters.reportingmonth,
        };
      });
    }
  }, [filters.reportingyear, filters.reportingmonth]);

  //use effect when profit and loss reporting year changes
  useEffect(() => {
    const isReportingYear = (item: any, filters: any) => {
      return (
        item.PeriodType === "RP" &&
        String(item.ReportingYear) === String(filters.plreportingyear)
      );
    };
    const RPMonths = reportingAndComparison
      .filter((item: any) => isReportingYear(item, filters))
      .map((item: any) => ({
        key: item.ReportingMonth,
        value: item.ReportingMonth,
      }));
    setDropdownOptions((prev: any) => ({
      ...prev,
      plreportingmonth: deduplicateByKey(RPMonths),
    }));
    setFilters((prev: any) => {
      return {
        ...prev,
        //plreportingmonth: RPMonths[0]?.key,
      };
    });
  }, [filters.plreportingyear]);

  //use effect when profit and loss cmparison year changes
  useEffect(() => {
    const isComparisonYear = (item: any, filters: any) => {
      return (
        item.PeriodType === "CP" &&
        String(item.ReportingYear) === String(filters.plcomparisonyear)
      );
    };
    const CPMonths = reportingAndComparison
      .filter((item: any) => isComparisonYear(item, filters))
      .map((item: any) => ({
        key: item.ReportingMonth,
        value: item.ReportingMonth,
      }));
    setDropdownOptions((prev: any) => ({
      ...prev,
      plcomparisonmonth: deduplicateByKey(CPMonths),
    }));
    setFilters((prev: any) => {
      const matchWithReportingMonth = CPMonths.find(
        (m: any) => String(m.key) === String(prev.reportingmonth),
      );
      return {
        ...prev,
        plcomparisonmonth: matchWithReportingMonth
          ? matchWithReportingMonth.key
          : CPMonths[0]?.key,
      };
    });
  }, [filters.plcomparisonyear]);

  //use effect when balance sheet comparison year changes
  useEffect(() => {
    const CPMonths = reportingAndComparison
      .filter(
        (item: any) =>
          item.PeriodType === "CP" &&
          item.ReportingYear === filters.comparisonyear,
      )
      .map((item: any) => ({
        key: item.ReportingMonth,
        value: item.ReportingMonth,
      }));
    setDropdownOptions((prev: any) => ({
      ...prev,
      comparisonmonth: deduplicateByKey(CPMonths),
    }));
    if (!queryParamsUsed && !queryParams.CompYear) {
      setFilters((prev) => ({
        ...prev,
        comparisonmonth: CPMonths[0]?.value,
      }));
    } else if (!queryParamsUsed && queryParams.CompMonthNo) {
      const matchedMonth = CPMonths.find(
        (opt: { value: number }) =>
          String(opt.value) === String(queryParams.CompMonthNo),
      );
      setFilters((prev: any) => ({
        ...prev,
        comparisonmonth: matchedMonth
          ? String(matchedMonth.value)
          : prev.comparisonmonth,
      }));
    } else {
      setFilters((prev) => {
        return {
          ...prev,
          comparisonmonth:
            prev.comparisonmonth &&
            CPMonths.some(
              (m: any) => String(m.value) === String(prev.comparisonmonth),
            )
              ? prev.comparisonmonth
              : CPMonths[1]?.value,
          // plcomparisonmonth: filters.comparisonmonth,
        };
      });
    }
  }, [filters.comparisonyear]);

  // useeffect to fetch threshold values
  useEffect(() => {
    if (
      !filters.companycodes ||
      (Array.isArray(filters.companycodes) &&
        (filters.companycodes.length === 0 ||
          (filters.companycodes.length === 1 &&
            filters.companycodes[0] === "")))
    ) {
      return;
    }
    const fetchThresholdValues = async () => {
      if (filters.companycodes && filters.companycodes !== "") {
        setLoading(true);
        let response = await getThresholdValues({
          landscapeId: landscapeId,
          companyCodes: companyCodesString,
        });
        if (response) {
          setThresholdValues(response[0]);
        }
        setLoading(false);
      }
    };
    fetchThresholdValues();
  }, [filters.companycodes]);
  return { filters, dropdownOptions, thresholdValues, handleFilterChange };
}
